import React, { Component, PropTypes } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import { SparkTable } from '../../../ui/spark';
import Validator from '../../../../utils/Validator';
import { LinkIcon } from '../../../assets/LinkIcon';
import InputTextField from 'components/common/InputTextField';

const validatorHelperBlur = (item, event) => {
    if (item.validator) {
        if (item.validator.type === 'float') {
            return Validator.validNumberFloat(event.target.value);
        } else if (item.validator.type === 'geo') {
            return Validator.validGeoCoordinate(event.target.value, item.validator.type_geo);
        } else {
            return Validator.validNumberInt(event.target.value, item.validator.min, item.validator.max);
        }
    } else {
        return event.target.value;
    }
};

const validatorHelperChange = (item, event) => {
    if (item.validator) {
        if (item.validator.type === 'float' || item.validator.type === 'geo') {
            return Validator.validNumberFloat(event.target.value);
        } else {
            return Validator.validNumberIntType(event.target.value);
        }
    } else {
        return event.target.value;
    }
};

const SortableItem = SortableElement(({ value, props, idx }) => (
    <tr>
        <td>
            <LinkIcon iconType="spark-icon-arrows-up-down" />
        </td>
        {props.columns.map((item2, idx2) => {
            return (
                <td key={item2.key + idx2}>
                    {item2.inputType && item2.inputType.toLowerCase() !== 'text' ? (
                        <input
                            onBlur={event => {
                                props.editConfigRow(item2.key, idx, validatorHelperBlur(item2, event));
                            }}
                            onChange={event => {
                                props.editConfigRow(item2.key, idx, validatorHelperChange(item2, event));
                            }}
                            name={value.key}
                            role="textbox"
                            type={item2.inputType ? item2.inputType : 'text'}
                            value={_.get(value, item2.key, '')}
                        />
                    ) : (
                        <InputTextField
                            onBlur={event => {
                                props.editConfigRow(item2.key, idx, validatorHelperBlur(item2, event));
                            }}
                            onChange={event => {
                                props.editConfigRow(item2.key, idx, validatorHelperChange(item2, event));
                            }}
                            name={value.key}
                            role="textbox"
                            type="text"
                            value={_.get(value, item2.key, '')}
                        />
                    )}
                </td>
            );
        })}
        <td>
            <button
                onClick={() => {
                    props.deleteConfigRow(idx);
                }}
                className="spark-btn--icon spark-icon spark-icon-trash spark-logo--xs"
                title="Delete row"
            />
        </td>
    </tr>
));

const SortableList = SortableContainer(({ props }) => {
    return (
        <tbody>
            {props.list.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} idx={index} value={value} props={props} />
            ))}
        </tbody>
    );
});

class TablePanelMulti extends Component {
    constructor(props) {
        super(props);
        this.onSortEnd = this.onSortEnd.bind(this);
    }

    componentDidMount() {
        this.themeTable = new SparkTable(this.themeTableMount);
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.props.changeConfigRow(oldIndex, newIndex);
    };

    render() {
        return (
            <div
                ref={node => {
                    this.themeTableMount = node;
                }}
            >
                <table
                    id={this.props.id + '-theme-panel-table'}
                    style={{ tableLayout: 'fixed' }}
                    className="col-lg-12 spark-table col-xs-12"
                    role="grid"
                >
                    <colgroup>
                        <col style={{ width: '60px' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '80px' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            {this.props.columns.map((item, idx) => {
                                return (
                                    <th key={item.key + idx} style={{ overflow: 'hidden' }}>
                                        {item.value}
                                    </th>
                                );
                            })}
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <SortableList props={this.props} onSortEnd={this.onSortEnd} helperClass={'spark-table'} />
                </table>
            </div>
        );
    }
}

TablePanelMulti.propTypes = {
    themes: PropTypes.array,
    onShowInfo: PropTypes.func,
    columns: PropTypes.array
};

export default TablePanelMulti;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/TablePanelMulti.js